import { z } from 'zod';

export const RuleTargetZod = z.discriminatedUnion('type', [
  z.object({ type: z.literal('field'), id: z.string().min(1) }).strict(),
  z.object({ type: z.literal('fieldInstance'), id: z.string().min(1) }).strict(),
  z.object({ type: z.literal('section'), id: z.string().min(1) }).strict(),
  z.object({ type: z.literal('tab'), id: z.string().min(1) }).strict(),
]);

export type RuleTarget = z.infer<typeof RuleTargetZod>;
